import {gsap, Draggable, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {BaseGameMNS2} from "../base/BaseGameMNS2";
import {Quiz} from "./Quiz";
import {BrainMaze} from "./BrainMaze";
import {ProgressUI} from "./ProgressUI";

// Constructor
export class CerveauApp extends BaseGameMNS2 {

  constructor() {
    super(`data/cerveau.json`);
    gsap.registerPlugin(Draggable)
    gsap.registerPlugin(InertiaPlugin)
  }

  // To be overridden in child games
  initGame() {

    // Seve final screen ID
    this.seveCtaScreenID = 8;
    this.seveCommunication.on("buttonPressed", (e) => this.onButtonPressed(e));

    this.lastSelectedAnswer = 'C';
    this.brassageCount = 0;
    this.brainMaze = new BrainMaze("#brainmaze", () => this.brainMazeTargetReached());

    // Create quizes objects
    this.quizes = [];
    for (let i = 1; i <= 3; i++) {
      const quiz = new Quiz(`#quiz-level${i}`, "#quiz-feedback-left");
      quiz.selectAnswerCallback = (optionValue) => this.onSelectAnswer(optionValue)
      quiz.feedbackShownCallback = (optionValue) => this.feedbackShownCallback(optionValue)
      quiz.quizCompletedCallback = (finalValue) => this.onQuizComplete(finalValue)
      quiz.showNextQuestionCallback = (finalValue) => this.onShowNextQuestion()
      this.quizes.push(quiz);
    }

    this.progressUI = new ProgressUI("#progress-ui");

    super.initGame();
    // TODO: For debugging
    // super.initGame(2);
    // super.initGame(4);
    // super.initGame(5);
    // super.initGame(6);
    // this.onQuizComplete("B")
  }

  onSelectAnswer(optionValue) {
    // console.log("onSelectAnswer", optionValue)
    this.lastSelectedAnswer = optionValue;
    const progress = (5 - this.getQuizForLevel().selectedQuestions.length);
    this.progressUI.setProgress(progress);
  }

  feedbackShownCallback(optionValue) {
    this.brainMaze.selectBoard(optionValue)
    // this.brainMaze.togglePionVisibility(this.getQuizForLevel().questionsAvailable());
  }

  onShowNextQuestion() {
    // console.log("onShowNextQuestion")
  }

  onQuizComplete(finalValue) {
    // console.log("onQuizComplete", finalValue)
  }

  // To be overridden in child games
  initScreen(screenId) {
    super.lottieAutoPlaybackForScreen(screenId);

    const screenIdNoLevel = parseInt(screenId.toString().replace("-" + this.level, ""));
    // console.log("initScreen ids:", {screenIdNoLevel: screenIdNoLevel, screenId: screenId});

    if (screenId === 1) {
      this.seveCommunication.sendMessage(0);

    } else if (screenIdNoLevel === 2) {
      this.seveCommunication.sendMessage(1);

    } else if (screenId === 3) {
      this.revealCard();

    } else if (screenId === 4) {
      // Toggle visibility of correct quiz
      for (let i = 1; i <= 3; i++) $(`#quiz-level${i}`).toggle(this.level === `level${i}`);
      // Toggle visibility for handcoach
      $("#screen-4 .handcoach").toggleClass("excluded", (this.getQuizForLevel().selectedQuestions.length !== 5))
      console.log($("#screen-4 .handcoach"), this.getQuizForLevel().selectedQuestions.length)
      // Show next question or end quiz
      this.getQuizForLevel().showNextQuestion()

    } else if (screenId === 5) {
      this.shakeDices(this.lastSelectedAnswer);

    } else if (screenId === 6) {
      // TODO add initialization if required
      this.brainMaze.enable()

    } else if (screenIdNoLevel === 7) {
      const resultIsC = this.getQuizForLevel().score.C > this.getQuizForLevel().score.S;
      $(".final-result-C").toggle(resultIsC)
      $(".final-result-S").toggle(!resultIsC)
      this.brainMaze.playEndAnimation(resultIsC ? "C" : "S", this.getQuizForLevel().score.C, this.getQuizForLevel().score.S);
      this.startResultRightBackgroundAnimation(screenId, (resultIsC ? "C" : "S"))
    } else if (screenId === 8) {
      this.seveCommunication.sendMessage(3);
      this.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_SFXpartage.mp3", 1, true)
      this.seveVideoPlayback("cta")
      // Auto quit app
      this.currentTimeline = gsap.timeline();
      this.currentTimeline.add(() => this.reset(), 14)
    }

    // Toggle brain maze visibility
    if (screenId === 1) this.brainMaze.hide();
    else this.brainMaze.show();

    // Toggle brain maze snooze visibility
    this.brainMaze.snooze([8, 9].includes(screenId))

    // Changle language switcher position
    this.setAdditionalToolsVisibility(![1,7].includes(screenIdNoLevel) && screenId !== this.seveCtaScreenID, [4].includes(screenIdNoLevel));

    this.showScreenTopTooltip(screenId);
  }

  getQuizForLevel() {
    if (this.level === "level2") return this.quizes[1];
    else if (this.level === "level3") return this.quizes[2];
    else return this.quizes[0];
  }

  pickACard() {
    this.goToScreen(3)
    this.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXquestion.mp3", 1, true)
  }

  revealCard() {
    this.currentTimeline = gsap.timeline();

    this.currentTimeline.add(() => {
      const lottie = $(`#card-${app.i18n.lang}`).data("lottie");
      lottie.setFrame(0);
      lottie.play();
    }, "<");

    this.currentTimeline.add(() => this.goToScreen(4), 1.5)
  }

  ctaShakeDices() {
    this.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXbrassage.mp3", 1, true)
    this.goToScreen(5)
  }

  shakeDices(type = "S") {

    // Define dice result
    const selectedResult = this.brainMaze.getRandomDiceResult(type, this.brassageCount);
    this.brainMaze.diceSequence.push(selectedResult.dice);

    // Shake dices
    $(".dice-result").hide();
    const shakingLottie = $("#shaking-dice").data("lottie");
    const resultLottie = $(`#dice-result-${selectedResult.dice}`).data("lottie");

    this.currentTimeline = gsap.timeline();
    this.currentTimeline.add(async () => {

      // Shake dice
      $(shakingLottie.canvas).show();
      await this.dotLottieCompletedPlayback(shakingLottie)
      $(shakingLottie.canvas).hide();

      // Show dice result
      this.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXdescore.mp3", 1, true)
      $(resultLottie.canvas).show();
      await this.dotLottieCompletedPlayback(resultLottie)
      $(resultLottie.canvas).hide();

      // Pass selectedResult to the brainMaze to place target
      this.brainMaze.setTarget(selectedResult)
      this.brassageCount += 1

      // Go to next screen
      this.goToScreen(6);
    });
  }

  restartQuiz() {
    this.getQuizForLevel().reset();
    this.brainMaze.gracefulReset();
    this.goToScreen(2)
  }

  brainMazeTargetReached() {
    console.log("brainMazeTargetReached");
    this.killTimeline(this.currentTimeline);
    this.currentTimeline = gsap.timeline();
    this.currentTimeline.add(() => this.goToScreen(3), 1.5);
    this.currentTimeline.add(() => this.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXquestion_sansclic.mp3", 1, true), 1.65);
  }

  goToConclusion() {
    const resultIsC = this.getQuizForLevel().score.C > this.getQuizForLevel().score.S;
    if (resultIsC) this.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXconclusioncortex.mp3", 1, true)
    else this.audio.play("audio/MNS2_Int3.2 Cerveau a l_ecoute_SFX/MNS2_ME_INT3.2_SFXconclusionstriatum.mp3", 1, true)
    this.goToScreen(7)
  }

  dotLottieCompletedPlayback(lottie) {
    return new Promise(resolve => {
      lottie.setFrame(0);
      lottie.removeEventListener('complete');
      lottie.addEventListener('complete', () => {
        lottie.removeEventListener('complete');
        resolve(true);
      });
      lottie.play();
    })
  }

  startResultRightBackgroundAnimation(screenId, result) {
    const element = $(`#screen-${screenId} .right-end-animation-${result}`);
    const rightAnimation = element.data("lottie");
    rightAnimation.play();
    gsap.set(element, {autoAlpha: 1})
  }

  updateSeveVideosSrc(language) {
    super.updateSeveVideosSrc(language,
      "videos/seve_A/ZONE3_ME_MNS2_VID_PARTAGE_SEVE_{{LANG}}_ecran_droite.mp4",
      "videos/seve_B/ZONE3_ME_MNS2_VID_SEVE_PARTAGER_{{LANG}}_ecran_droite.mp4"
    );
  }

  static bringInCTA(selector) {
    return gsap.fromTo(selector, {
      scale: 0,
    }, {
      autoAlpha: 1,
      scale: 1,
      ease: "ease.in",
      transformOrigin: "bottom center",
      duration: 0.5
    })
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {
    // TODO: Reset things here

    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);

    const resetCallback = () => {
      // Things that reset after goToScreen
      this.seveVideoPlayback("none")

      this.brainMaze.reset();
      this.brassageCount = 0;
      for (let i = 0; i < this.quizes.length; i++) this.quizes[i].reset();
      this.progressUI.reset();
      this.seveVideoPlayback("none")

      // Stop screen 7 animations
      $(`.right-end-animations canvas`, "#screen-7-LEVEL1, #screen-7-LEVEL2, #screen-7-LEVEL3").each((index, element) => {
        const rightAnimation = $(element).data("lottie");
        rightAnimation.stop();
        gsap.set(element, {autoAlpha: 0})
      })
    }

    // Super
    return super.reset(screenId, resetCallback);

  }

}
